import { PAGE_HOME_URL, PAGE_INCLUSIONE_VOGLIO_SAPERNE_DI_PIU_EXTRASCOLASTICO, PAGE_HOME_INCLUSIONE, PAGE_ORIENTAMENTO_SCOLASTICO_ED_EXTRA } from 'types/url';

export const BreadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Orientamento scolastico ed extrascolastico',
    url: PAGE_ORIENTAMENTO_SCOLASTICO_ED_EXTRA,
  },
  {
    slash: 'VOGLIO SAPERE DI PIÙ SUL SERVIZIO',
    url: PAGE_INCLUSIONE_VOGLIO_SAPERNE_DI_PIU_EXTRASCOLASTICO,
  },
];

export const title = 'WeMi - Inclusione - Orientamento scolastico ed extrascolastico - Voglio sapere di più sul servizio';
export const description = 'Descrizione servizio scolastico ed extrascolastico';
export const keywords = 'welfare, milano, servizi, servizio, Orientamento scolastico ed extrascolastico voglio sapere di più sul servizio , servizio Orientamento scolastico ed extrascolastico, informazioni orientamento scolastico ed extrascolastico';
